import CONFIG from '@/configs/config'
import { Get } from '@/utils/RequestService'
import Constant from '@/configs/constant'

var apiUrl = CONFIG.API_URL
var service = {
  getSystemConfig: () => Get(`${apiUrl}config`),
  getLanguages: () => Get(`${Constant.LANGUAGE_LINK}/config.json`)
}

export default service
